import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import Badge from 'components/Badge'
import styles from './NewsCard.module.sass'

const NewsCard = ({
  anchor,
  badgeText,
  badgeImg,
  category,
  title,
  description,
  url
}) => {
  const articleUrl = '/article/' + url

  const handleScrollToTop = () => {
    setTimeout(() => window.scrollTo({ top: 0, behavior: 'smooth' }), 100)
  }

  return (
    <div className={styles.card} id={`article${anchor}`}>
      <div className={styles.badge}>
        <Badge
          text={badgeText}
          icon={badgeImg || require('images/abstract.png')}
        />
        <p className={styles.category}>
          {category === 'abstracts' ? 'abstract' : category}
        </p>
      </div>
      <Link
        to={articleUrl}
        onClick={() => handleScrollToTop()}
        onKeyDown={e => {
          if (e.key === 'Enter' || e.key === ' ') handleScrollToTop()
        }}
      >
        <p
          dangerouslySetInnerHTML={{ __html: title }}
          className={styles.title}
        />
      </Link>
      <p className={styles.description}>
        {description}
        {url && (
          <Link
            className={styles.readmore}
            to={articleUrl}
            onClick={() => handleScrollToTop()}
            onKeyDown={e => {
              if (e.key === 'Enter' || e.key === ' ') handleScrollToTop()
            }}
          >
            read more
          </Link>
        )}
      </p>
    </div>
  )
}

NewsCard.propTypes = {
  anchor: PropTypes.number,
  badgeText: PropTypes.string,
  badgeImg: PropTypes.string,
  category: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string,
  url: PropTypes.string
}

export default NewsCard
